import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, MaybeAsync, Resolve, RouterStateSnapshot } from "@angular/router";
import type { Category } from "@ophardt/shopware-api";
import { CategoryService } from "@shared/services/category.service";

@Injectable({
  providedIn: "root",
})
export class CategoriesResolver implements Resolve<Category[]> {
  private readonly categoryService = inject(CategoryService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<Category[]> {
    return this.categoryService.getAllNavigationCategories();
  }
}
